import { Component, inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';

import AdminHelpers from '../../helpers/helpers';
import { UsersService } from '../../services/users.service';

@Component({
  selector: 'app-add-admin-user-modal',
  templateUrl: './add-admin-user-modal.component.html',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
})
export class AddAdminUserModalComponent {
  isSubmitting: boolean;
  showPhone = false;
  email: string;
  phoneNumber: string;

  usersService: UsersService;
  toastr: ToastrService;
  modal: NgbActiveModal;

  constructor() {
    this.usersService = inject(UsersService);
    this.toastr = inject(ToastrService);
    this.modal = inject(NgbActiveModal);
  }

  public save(f: NgForm): void {
    if (f.invalid) {
      AdminHelpers.markFormInvalidAndFocus(f);
    } else {
      this.isSubmitting = true;
      f.form.disable();

      if (!this.phoneNumber) {
        this.usersService
          .setUserAsSuperAdmin(this.email)
          .pipe(
            finalize(() => {
              this.isSubmitting = false;
              f.form.enable();
            })
          )
          // eslint-disable-next-line sonarjs/deprecation
          .subscribe(
            () => {
              this.toastr.success('The user has been assigned as a user admin');
              this.modal.close();
            },
            (err) => {
              if (err.message == 'ERROR.USER_DONT_EXIST') {
                this.toastr.toastrConfig.autoDismiss = false;
                this.toastr.warning('User Does Not Exist, Try To Create The User');
                this.showPhone = true;
                this.toastr.toastrConfig.autoDismiss = true;
                return;
              }

              this.toastr.error(err.message);
            }
          );
        return;
      }

      this.usersService
        .createUserAsSuperAdmin(this.email, this.phoneNumber)
        .pipe(
          finalize(() => {
            this.isSubmitting = false;
            f.form.enable();
          })
        )
        // eslint-disable-next-line sonarjs/deprecation
        .subscribe(
          () => {
            this.toastr.success('The user has been assigned as a user admin');
            this.modal.close();
          },
          (err) => {
            this.toastr.error(err.message);
          }
        );
    }
  }
}
